import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const perfilEmpleadoImporterSelectors = importerSelectors(
  'perfilEmpleado.importer',
);

export default perfilEmpleadoImporterSelectors;
